import { RoleChoices } from 'generated/graphql'

export const transformRoleFromValueToEnumValue = (role: string) => ({
    'Primary speaker': RoleChoices.PrimarySpeaker,
    Speaker: RoleChoices.Speaker,
    Moderator: RoleChoices.Moderator,
    Audience: RoleChoices.Audience
})[role] || RoleChoices.Audience
